<template>
  <div ref="el">
    <hr
      role="separator"
      height="7"
      aria-orientation="horizontal"
      class="v-divider"
      theme="light"
    />
    <v-list-group class="postition-group" selected-class="text-grey" :value="value">
      <template #activator="{props}">
        <v-list-item class="position-header pr-3" v-model="pickData.done" :key="`${position.Belegnr}-${position.Posnr}`"
                     v-bind="props">
          <template #prepend>
            <div style="position: relative; ">
              <v-scroll-x-transition>
                <v-icon v-if="pickData.done && pickData.overbooked" class="mr-2" color="warning">
                  mdi-checkbox-marked-circle-plus-outline
                </v-icon>
                <v-icon v-else-if="pickData.done && !pickData.overbooked" class="mr-2" color="success">
                  mdi-checkbox-marked-circle-outline
                </v-icon>
                <v-icon v-else-if="pickData.full" class="mr-2" color="warning">
                  mdi-alert
                </v-icon>
                <v-icon v-else-if="!pickData.valid || (pickData.qty <= 0 && picklist.isSuggestion)" class="mr-2"
                        color="error">
                  mdi-alert-remove
                </v-icon>
              </v-scroll-x-transition>
            </div>
          </template>
          <v-list-item-title :class="(pickData.done && 'text-grey done') || ''">
            <b><ScrollText :text="position.Bezeichn1" :disable="!expanded"/></b>
          </v-list-item-title>
          <v-list-item-subtitle v-if="position.Bezeichn2">
            <ScrollText :text="position.Bezeichn2" :disable="!expanded"/>
          </v-list-item-subtitle>
          <v-list-item-subtitle v-if="pickData.bookings.length === 1" class="mx-n1">
            <template v-if="pickData.bookings[0].batchNo && pickData.bookings[0].nve">
              <v-chip size="x-small" class="mx-1">{{ pickData.bookings[0].batchNo }}</v-chip>
              <v-chip size="x-small" class="mx-1">{{ pickData.bookings[0].nve }}</v-chip>
            </template>
            <template v-else-if="pickData.bookings[0].nve">
              <v-chip size="x-small" class="mx-1">{{ pickData.bookings[0].nve }}</v-chip>
            </template>
            <template v-else-if="pickData.bookings[0].batchNo">
              <v-chip size="x-small" class="mx-1">{{ pickData.bookings[0].batchNo }}</v-chip>
            </template>
            <template v-else-if="pickData.bookings[0].serialNo">
              <v-chip size="x-small" class="mx-1">{{ pickData.bookings[0].serialNo }}</v-chip>
            </template>
          </v-list-item-subtitle>
          <template #append>
            <div class="d-flex align-center justify-end ml-n16">
              <div class="position-amount-wrapper py-2">
                <v-chip
                  class="position-amount"
                  size="x-small"
                  variant="outlined"
                  :color="pickData.done ? ' lighten-4' : ''"
                >
                  <span
                    :class="pickData.done ? 'text-grey done' : ''"
                  >
                    <b>
                      {{ pickedCount ? pickedCount : '0' }}<template v-if="position.Menge">/{{
                        position.Menge
                      }}</template>
                    </b> {{ position.Einheit }}
                  </span>
                </v-chip>
                <v-chip v-if="pickData?.qtyGebinde !== null" size="x-small" variant="outlined"
                        class="position-amount ml-auto" :color="pickData.done ? 'grey-darken-1' : 'grey-darken-1'">
                  <span :class="pickData.done ? 'text-grey done' : 'text-primary'"
                  ><b>
                    {{ roundToOneOverX(pickData?.qtyGebinde) }}<template v-if="position.Menge">/{{
                      position.Gebindemenge
                    }}</template>
                  </b> {{ position.Gebindeinh }}</span>
                </v-chip>
              </div>
              <v-icon :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"/>
            </div>
          </template>
        </v-list-item>
      </template>

      <div v-if="bookings.length > 1">
        <v-dialog
          v-model="bookingModal"
          fullscreen
          scrollable
          :scrim="false"
        >
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              block
              size="large"
              class="text-white rounded-0"
              color="blue-accent-2"
              elevation="0"
            >
              +{{ bookings.length - 1 }} Buchungen
            </v-btn>
          </template>
          <v-card
            rounded="0"
            elevation="0"
            color="grey-lighten-3"
          >
            <v-toolbar theme="dark" color="primary">
              <v-toolbar-title>Weitere Buchungen</v-toolbar-title>
              <v-toolbar-items>
                <v-btn class="rounded-0" @click="bookingModal = false">
                  Schließen
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <template v-for="i in (bookings.length ? bookings.length - 1 : 0)" :key="i">
                <v-card class="mb-5">
                  <v-card-title>
                    <v-layout d-flex justify-space-between>
                      <div>Buchung #{{ i }}</div>
                      <v-spacer/>
                      <v-btn
                        variant="flat"
                        @click="deleteBooking(i - 1)"
                        color="error"
                      >
                        <v-icon size="large">mdi-delete</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-card-title>
                  <booking-item
                    :booking-index="i - 1"
                    :picklist="picklist"
                    :position-index="positionIndex"
                    @reset-position="resetPosition"
                    @delete-position="deletePosition"
                    :deletable="deletable"
                    readonly
                  />
                </v-card>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <!--
      <v-select
        :items="bookingItems"
        v-model="selectedBooking"
        class="grey-lighten-4"
        filled
        dense
      />
      -->
      <booking-item
        v-if="booking"
        :booking-index="bookingIndex"
        :picklist="picklist"
        :position-index="positionIndex"
        @reset-position="resetPosition"
        @delete-position="deletePosition"
        :deletable="deletable"
      />
      <v-card-text
        v-if="picklistPicker.picklist?.mayAddBooking"
        class="pt-0"
      >
        <v-btn
          @click="addBooking"
          class="rounded-0"
          block
          size="large"
          color="secondary"
          elevation="0"
          :disabled="!booking.valid || booking.qty <= 0"
        >
          <v-icon start>mdi-plus</v-icon>
          Teilbuchung hinzufügen
        </v-btn>
      </v-card-text>
      <hr
        role="separator"
        aria-orientation="horizontal"
        class="v-divider"
        theme="light"
      />

      <v-list-item class="px-0 bg-grey-lighten-4 remove-padding">
        <v-table class="my-5 bg-grey-lighten-4">
          <tbody>
          <tr>
            <td>Belegnummer</td>
            <td>{{ position.Belegnr ? position.Belegnr : '–' }}</td>
          </tr>
          <tr>
            <td>Positionsnummer</td>
            <td>{{ position.Posnr }}</td>
          </tr>
          <tr>
            <td>Artikelnummer</td>
            <td>{{ position.Artikelnr }}</td>
          </tr>
          <tr v-if="position.ChargenpflichtBool">
            <td>Chargenpflicht</td>
            <td>
              <v-chip :color="position.ChargenpflichtBool ? 'green' : 'red'" size="small" class="px-1" variant="flat">
                <v-icon
                  color="white"
                  size="small">
                  {{ position.ChargenpflichtBool ? 'mdi-check' : 'mdi-window-close' }}
                </v-icon>
              </v-chip>
            </td>
          </tr>
          <tr v-if="position.SeriennrpflichtBool">
            <td>Seriennrpflicht</td>
            <td>
              <v-chip :color="position.SeriennrpflichtBool ? 'green' : 'red'" size="small" class="px-1" variant="flat">
                <v-icon
                  color="white"
                  size="small"
                >
                  {{ position.SeriennrpflichtBool ? 'mdi-check' : 'mdi-window-close' }}
                </v-icon>
              </v-chip>
            </td>
          </tr>
          <tr>
            <td>Gruppenbezeichnung</td>
            <td>{{ position.GruppenBezeichnung }}</td>
          </tr>
          </tbody>
        </v-table>
      </v-list-item>
    </v-list-group>
  </div>
</template>

<script setup lang="ts">
import {ref, computed, watch} from 'vue';
import Picklist from '@/model/Picklist';
import BookingItem from './PositionItem/BookingItem.vue';
import {roundToOneOverX, doConfirm} from '@/util';
import {usePicklistPickerStore} from '@/store/picklistPickerV2';
import ScrollText from '@/components/ScrollText.vue';

const props = defineProps({
  positionIndex: {
    type: Number,
    required: true,
  },
  picklist: {
    type: Picklist,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  deletable: {
    type: Boolean,
    default: false,
  },
  value: {
    type: [Number, String],
    required: true,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits({
  deletePosition() {
    return true;
  },
  'update:modelValue'(val: boolean) {
    return typeof val === 'boolean';
  },
});

const bookingModal = ref(false);
// TODO: automatisches Öffnen/Schließen

const picklistPicker = usePicklistPickerStore();
const position = computed(() => props.picklist.allPositions[props.positionIndex]);

const pickData = computed(() => {
  return picklistPicker.getPickData(position.value);
});
const pickedCount = computed(() => {
  return pickData.value?.bookings?.reduce((cum, b) => cum + b.qty, 0) ?? 0;
});

const pickedPercentage = computed(() => {
  return Math.round((pickedCount.value / position.value.Menge) * 100);
});

const bookings = computed(() => {
  return pickData.value?.bookings ?? [];
});

const bookingItems = computed((): Array<{ text: string | number | object, value: string | number | object }> => {
  return bookings.value.map(
      (b, i) => ({
        value: i,
        text: `Lager ${b.warehouse}${b.batchNo ? ` – Chargennummer ${b.batchNo}` : ''}${b.serialNo ? ` – Seriennummer ${b.serialNo}` : ''}`,
      }),
  );
});
const bookingIndex = computed((): number => {
  return bookings.value.length ? bookings.value.length - 1 : 0;
});
const booking = computed(() => {
  return picklistPicker.getBooking(position.value, bookingIndex.value);
});


const addBooking = async () => {
  try {
    if (picklistPicker.picklist?.BestellNr !== null && pickData.value.qty >= pickData.value.position.Menge && !await doConfirm('Diese Position ist bereits voll. Trotzdem Teilbuchung anlegen?', 'Bereits vorhanden')) throw new Error('Vorgang abgebrochen');
    picklistPicker.getBooking(position.value);
  } catch (err) {
    console.error(err);
  }
};
const deleteBooking = async (id: number) => {
  if (!await doConfirm(`Buchung #${id + 1} wirklich löschen?`, 'Wirklich löschen?')) return;
  picklistPicker.deleteBooking(position.value, id);
  if (bookings.value.length < 2) {
    // Modal schließen, wenn keine Buchungen mehr darin
    bookingModal.value = false;
  }
};

watch(computed(() => pickData.value.done), (done: boolean, oldDone: boolean) => {
  if (oldDone || !done) return;

  if (picklistPicker.selectedPosition === props.positionIndex) {
    picklistPicker.selectedPosition = null;
  }
});

const el = ref(null as HTMLDivElement | null);
let timeout: NodeJS.Timeout | null = null;
watch(() => props.expanded, async (expandedVal) => {
  if (timeout) clearInterval(timeout);
  if (expandedVal) {
    const itemEl = el.value?.querySelector('.v-list-group__items');
    let lastHeight = itemEl?.clientHeight ?? 0;
    timeout = setInterval(async () => {
      const itemEl = el.value?.querySelector('.v-list-group__items');
      if (itemEl?.clientHeight === 0) return;
      if (itemEl?.clientHeight !== lastHeight) {
        lastHeight = itemEl?.clientHeight ?? 0;
        return;
      }
      if (timeout) clearInterval(timeout);
      const appBar = document.getElementById('mainAppBar');
      const topOffset = (appBar?.clientHeight ?? 64);
      const scrollTop = (document.scrollingElement?.scrollTop ?? 0);
      const clientRectTop = el.value?.getBoundingClientRect().top ?? 0;
      const newPosition = clientRectTop - topOffset + scrollTop;
      window.scroll(0, newPosition);
      console.log('scrolled to', document.scrollingElement?.scrollTop);
    }, 50);
  }
});

function resetPosition() {
  picklistPicker.clearBookings(position.value);
}

function deletePosition() {
  emits('deletePosition');
}

defineExpose({
  BookingItem,
  bookingModal,
  position,
  pickData,
  pickedCount,
  pickedPercentage,
  bookings,
  bookingItems,
  bookingIndex,
  picklistPicker,
  booking,
  addBooking,
  deleteBooking,
  roundToOneOverX,
  resetPosition,
  deletePosition,
  el,
});

</script>
<style scoped lang="scss">
@keyframes scrollText {
  0%, 20%, 100% {
    transform: translateX(0%);
  }
  50%, 70% {
    transform: translateX(calc(100vw - 100% - 60px /* padding and icon */));
  }
}

.scrolling-text {
  display: inline-block;
  overflow: unset;
  text-overflow: unset;
  white-space: nowrap;
  animation: scrollText 7.5s linear infinite;
}

.v-list-item__icon {
  min-width: fit-content;
  margin-right: 0px !important;
}

.v-data-table {
  width: 100%;
}

.position-amount-wrapper {
  text-align: center;
  flex: 0;
}

.position-amount {
  justify-content: flex-end;
}

.v-list-group:v-deep > .v-list-item {
  padding-left: 16px !important;
}

.position-group :deep(.v-list-item) {
  max-width: 100vw;
}

.remove-padding {
  padding-inline-start: 0px !important;
}

.v-list-item-title, .v-list-item-subtitle {
  text-overflow: unset;
  white-space: nowrap;
}
</style>

<style lang="scss">
.v-list-item__icon {
  align-self: center;
}

.v-list-group__header__prepend-icon {
  order: 999;
  margin-right: -8px !important;
  margin-left: 0px !important;
}
</style>
